import { render, staticRenderFns } from "./editArticleHolder.vue?vue&type=template&id=66014d9d&scoped=true"
import script from "./editArticleHolder.vue?vue&type=script&lang=js"
export * from "./editArticleHolder.vue?vue&type=script&lang=js"
import style0 from "./editArticleHolder.vue?vue&type=style&index=0&id=66014d9d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66014d9d",
  null
  
)

export default component.exports